import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box } from '@material-ui/core';
import { RequestStatus } from '../types';
import { formatUtc } from '../../../shared/utils';
import { UserRequestStatusIcon } from '../../icons/UserRequestStatusIcon';

export const buildIntakeRequestColumns = (
  formatDate: (dateIso?: string | null) => string = formatUtc,
): GridColDef[] => {
  return [
    {
      flex: 1,
      field: 'id',
      headerName: 'Request ID',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{params.row.requestId}</span>
      ),
    },
    {
      flex: 1.2,
      field: 'submittedAt',
      headerName: 'Date Submitted',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{formatDate(params.row.submittedAt)}</span>
      ),
    },
    {
      flex: 1,
      field: 'requestType',
      headerName: 'Request Type',
      disableColumnMenu: true,
    },
    {
      flex: 1,
      field: 'name',
      headerName: 'Name',
      disableColumnMenu: true,
    },
    {
      flex: 1,
      field: 'email',
      headerName: 'Email',
      disableColumnMenu: true,
    },
    {
      flex: 1,
      field: 'status',
      headerName: 'Status',
      disableColumnMenu: true,
      minWidth: 160,
      sortComparator: (v1, v2) => {
        const order: Partial<Record<RequestStatus, number>> = {
          New: 0,
          'In progress': 1,
          Resolved: 2,
          Canceled: 3,
        };
        const a = order[(v1 as RequestStatus) ?? 'Canceled'];
        const b = order[(v2 as RequestStatus) ?? 'Canceled'];
        return (a ?? 0) - (b ?? 0);
      },
      renderCell: (params: GridRenderCellParams) => (
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <UserRequestStatusIcon status={params.value} />
          <span style={{ marginLeft: 8 }}>{params.value}</span>
        </Box>
      ),
    },
    {
      flex: 2,
      field: 'resolutionComment',
      headerName: 'Resolution Comment',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{params.row?.resolutionComment || '-'}</span>
      ),
    },
  ];
};
